import React from 'react';
import { getSmsFeePaymentConfigByPublicPath, getSmsFeePublicPathFromCallbackPathname, resolveSmsFeeTrackingRef } from '../../config/smsFeePaymentPages';

const SmsFeePaymentCallback = ({ match, location, history }) => {
  const status = match.params.status;
  const pathname = (location && location.pathname) || '';
  const publicPath = getSmsFeePublicPathFromCallbackPathname(pathname);
  const pageConfig = publicPath ? getSmsFeePaymentConfigByPublicPath(publicPath) : null;

  const state = (location && location.state) || {};
  const trackingRef = resolveSmsFeeTrackingRef({
    hawb: state.hawb,
    xlt: state.xltID
  });

  if (!pageConfig) {
    return (
      <div className='sms-content-wrap'>
        <p className='sms-message'>סוג תשלום לא מוכר.</p>
      </div>
    );
  }

  const { copy } = pageConfig;

  function renderContent() {
    if (status === 'success') {
      return (
        <>
          <h1>{copy.successTitle}</h1>
          {copy.successBody({ trackingRef })}
          <button type='button' className='btn medium orange centered' onClick={() => history.push(`/tracking/${trackingRef}`)}>מעקב משלוח</button>
        </>
      );
    }

    if (status === 'error') {
      return (
        <div className='sms-message'>
          <h1>
            {copy.errorPrefix}
            {' '}
            {location.state && location.state.body && location.state.body.ErrorText && `(${location.state.body.ErrorText})`}
            .
            <br />
            אנא נסו שוב או צרו קשר עם שירות הלקוחות.
          </h1>
          {location.state && location.state.body && location.state.body.ErrorCode && (
            <p>קוד שגיאה: {location.state.body.ErrorCode}</p>
          )}
        </div>
      );
    }

    if (status === 'cancelled') {
      return (
        <div className='sms-message'>
          <h1>{copy.cancelledTitle}</h1>
        </div>
      );
    }

    console.error(`Unexpected status ${status}`);
    return null;
  }

  return (
    <div className='sms-content-wrap'>
      {renderContent()}
    </div>
  );
};

export { SmsFeePaymentCallback };
